export const DEFAULT_TRANSITION = { ease: 'easeOut', duration: 0.2, bounce: 0 };
